import { updateLogs } from "@/mocks/home";

export default function UpdateLog() {
  return (
    <section id="logs" className="w-full bg-background-50 px-4 py-16 md:px-6 md:py-24">
      <div className="mx-auto w-full max-w-4xl">
        <div className="max-w-xl">
          <span className="font-label text-xs tracking-[0.3em] text-primary-600">UPDATE LOG</span>
          <h2 className="mt-3 font-heading text-2xl font-bold text-foreground-950 md:text-4xl">
            新地址更新日志
          </h2>
          <p className="mt-4 text-sm leading-relaxed text-foreground-600 md:text-base">
            爱黑料网新地址的每一次变动都会记录在这里，包含更换原因与时间，方便你对照当前入口是否已过期。
          </p>
        </div>

        <ol className="relative mt-10 md:mt-14">
          <span className="absolute left-[7px] top-2 h-[calc(100%-1rem)] w-px bg-background-300"></span>
          {updateLogs.map((log) => (
            <li key={log.date} className="relative flex gap-5 pb-9 last:pb-0 md:gap-7">
              <span className="relative z-10 mt-1 flex h-3.5 w-3.5 shrink-0 items-center justify-center rounded-full border-2 border-primary-500 bg-background-50"></span>
              <div className="flex-1 rounded-lg border border-background-200 bg-background-100/60 p-5 md:p-6">
                <div className="flex flex-wrap items-center gap-3">
                  <span className="rounded-md bg-accent-100 px-2.5 py-1 text-xs font-medium text-accent-900">
                    {log.badge}
                  </span>
                  <span className="font-label text-xs text-foreground-500">{log.date}</span>
                </div>
                <h3 className="mt-3 font-heading text-lg font-bold text-foreground-950">
                  {log.title}
                </h3>
                <p className="mt-2 text-sm leading-relaxed text-foreground-600">{log.desc}</p>
              </div>
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
}